// extracted by mini-css-extract-plugin
module.exports = {"padding-col":"PersonalDataFormStep_padding-col__k8f0S","label-text":"PersonalDataFormStep_label-text__nysKl"};